import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const publicStore = {
  state: {
    loading: false,
    settings: {
      categories: [],
      tasteprofiles: [],
      autosuggest: [
        {
          name: 'recepes',
          data: []
        },
        {
          name: 'ingredients',
          data: []
        }
      ]
    }
  },
  mutations: {
    setLoading (state, value) {
      state.loading = value
    },
    setSettings (state, value) {
      state.settings = value
    }
  },
  actions: {
    getSettings (store, courseName) {
      let url = `${process.env.VUE_APP_WINE_SPICE_URL || ''}/api/settings`
      return fetch(url, {
        method: 'GET'
      })
        .then(result => {
          return result.json()
        })
        .then(result => {
          store.commit('setSettings', result)
        })
    },
    getCourse (store, courseName) {
      store.commit('setLoading', true)
      let url = `${process.env.VUE_APP_WINE_SPICE_URL || ''}/api/coursesearch`
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ q: courseName })
      })
        .then(result => {
          store.commit('setLoading', false)
          return result.json()
        })
    },
    getRecommedation (store, ingredients) {
      store.commit('setLoading', true)
      let url = `${process.env.VUE_APP_WINE_SPICE_URL || ''}/api/recommendations`
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ ingredients })
      })
        .then(result => {
          store.commit('setLoading', false)
          return result.json()
        })
    },
    getProducts (store, settings) {
      store.commit('setLoading', true)
      const price = settings.price ? `&pmin=${settings.price.min || 0}%2C00&pmax=${settings.price.max || 1000}%2C00` : ''

      const searchString = settings.search ? `/zoeken/?q=${settings.search} .` : null
      const tasteProfileString = settings.tasteProfile ? `/wijn/?prefn1=tasteProfile&prefv1=${settings.tasteProfile}` : ''
      const path = settings.path ? settings.path + '?' : null
      let url = `${process.env.VUE_APP_SHOP_URL || ''}${path || searchString || tasteProfileString}&start=0${price}&async=true`
      return fetch(url)
        .then(result => {
          store.commit('setLoading', false)
          return result.text()
        })
    },
    recordAnalyticsEvent (store, { category, action, label }) {
      const dataLayerItem =
      {
        event: 'genericEvent',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
      }
      if (window.dataLayer) {
        window.dataLayer.push(dataLayerItem)
      } else {
        console.log(dataLayerItem)
      }
    }
  }
}

const store = {
  modules: {
    public: publicStore
  }
}

export default new Vuex.Store(store)
